<template>
  <v-container :fluid='fluid' ref='mainContainer' :key='renderCount'>
    <v-row v-for='r in rows' :key='r' :align='align' :dense='dense' :justify='justify' :noGutters='noGutters'>
      <v-col v-for='c in columns' :key='c' v-if='slotIndex(r, c, columns) <= slots'>
        <div ref='slotDiv'>
          <span ref='slotSpan'>
            <slot :name='"slot" + slotIndex(r, c, columns)'>
              {{ (debug ? `slot ${slotIndex(r, c, columns)}` : '') }}
            </slot>
          </span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  beforeCreate() {
    // console.debug('beforeCreate');
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    slots: {
      type: Number,
      required: true,
      default: 12,
    },
    slotWidth: {
      type: Number,
      required: true,
      default: 400,
    },
    slotHeight: {
      type: Number,
      default: null,
    },
    debug: {
      type: Boolean,
      default: false,
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    justify: {
      type: String,
      default: undefined,
    },
    'no-gutters': {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rows: null,
      columns: null,
      renderCount: 0,
    };
  },
  created() {
    if (this.debug) console.debug('created');
    window.addEventListener('resize', this.reRender);
  },
  beforeMount() {
    if (this.debug) console.debug('beforeMount');
  },
  mounted() {
    if (this.debug) console.debug('mounted');
    this.init();
  },
  beforeUpdate() {
    if (this.debug) console.debug('beforeUpdate');
    this.setGridParameters();
  },
  updated() {
    if (this.debug) console.debug('updated');
    this.setDivStyles();
    this.setSpanStyles();
  },
  beforeDestroy() {
    if (this.debug) console.debug('beforeDestroy');
  },
  destroyed() {
    if (this.debug) console.debug('destroyed');
    window.removeEventListener('resize', this.reRender);
  },
  methods: {
    init() {
      this.retardedReRender(0);
    },
    reRender() {
      if (this.visible) this.renderCount++;
    },
    retardedReRender(delay = 300) {
      let self = this;
      window.setTimeout((self) => { self.reRender(); }, delay, self);
    },
    setGridParameters() {
      this.columns = this.columnCount(this.containerWidth(), this.slotWidth);
      this.rows = this.rowCount(this.slots, this.columns);
    },
    containerWidth() {
      return this.$refs.mainContainer.offsetWidth;
    },
    slotIndex(rowIndex, columnIndex, columnCount) {
      return (rowIndex - 1) * columnCount + columnIndex;
    },
    rowIndex(slotIndex, columnCount) {
      return Math.ceil(slotIndex / columnCount);
    },
    columnIndex(slotIndex, columnCount) {
      let val = slotIndex % columnCount;
      if (val === 0) return columnCount;
      return val;
    },
    rowCount(slotCount, columnCount) {
      return Math.ceil(slotCount / columnCount);
    },
    columnCount(containerWidth, slotWidth) {
      let val = Math.floor(containerWidth / slotWidth);
      if (val < 1) return 1;
      return val;
    },
    isInLastRow(slotIndex, slotCount, columnCount) {
      const lastRowIndex = this.rowCount(slotCount, columnCount);
      const slotRowIndex = this.rowIndex(slotIndex, columnCount);
      return lastRowIndex === slotRowIndex;
    },
    lastRowColumnCount(slotCount, columnCount) {
      return this.columnIndex(slotCount, columnCount);
    },
    setDivStyles() {
      for (let i = 1; i <= this.slots; i++) this.$refs.slotDiv[i - 1].style = this.getDivStyle(i, this.slots, this.columns);
    },
    getDivStyle(slotIndex, slotCount, columnCount) {
      let divStyle = (this.slotHeight !== null ? `height: ${this.slotHeight}px;` : '');
      const columns = (this.isInLastRow(slotIndex, slotCount, columnCount) ? this.lastRowColumnCount(slotCount, columnCount) : columnCount);
      const columnIndex = this.columnIndex(slotIndex, columnCount);
      if (columnIndex <= Math.ceil(columns / 2)) divStyle += `text-align: left;`;
      else divStyle += `text-align: right;`;
      if (this.debug) divStyle += 'border: solid 1px;';
      return divStyle;
    },
    setSpanStyles() {
      for (let i = 1; i <= this.slots; i++) this.$refs.slotSpan[i - 1].style = this.getSpanStyle(i, this.slots, this.columns);
    },
    getSpanStyle(slotIndex, slotCount, columnCount) {
      let spanStyle = '';
      const columns = (this.isInLastRow(slotIndex, slotCount, columnCount) ? this.lastRowColumnCount(slotCount, columnCount) : columnCount);
      const columnIndex = this.columnIndex(slotIndex, columnCount);
      const outerWidth = this.$refs.slotDiv[slotIndex - 1].offsetWidth;
      const innerWidth = this.$refs.slotSpan[slotIndex - 1].offsetWidth;
      const diff = outerWidth - innerWidth;
      let margin = 0;
      if (diff > 0 && columns > 0) margin = diff * (columnIndex - 1) / (columns - 1);
      if (columnIndex <= Math.ceil(columns / 2)) spanStyle = `margin-left: ${margin}px;`;
      else spanStyle = `margin-right: ${diff - margin}px;`;
      if (this.debug) spanStyle += 'border: solid 1px;';
      return spanStyle;
    },
  },
  watch: {
    visible() {
      this.reRender();
    },
  },
};
</script>